import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { City } from './city.interface';
import { CityService } from './city.service';

const service = new CityService();

export interface CityState {
   cities: Array<City>;
}

const CityStore: Module<CityState, StoreState> = {
   namespaced: true,
   state: {
      cities: [],
   },
   getters: {
      cities: (state) => state.cities,
   },
   mutations: {
      SET_CITIES(state, cities: Array<City>) {
         state.cities = cities;
      },
   },
   actions: {
      async searchCities(context, query?: LocationQuery) {
         return await service.getCities(query);
      },
      async getCities(context, query?: LocationQuery) {
         const cities = await service.getCities(query);
         context.commit('SET_CITIES', cities);
         return cities;
      },
   },
};

export default CityStore;
